import { render, staticRenderFns } from "./cardSubheader.vue?vue&type=template&id=fcb93b16&scoped=true&"
import script from "./cardSubheader.vue?vue&type=script&lang=js&"
export * from "./cardSubheader.vue?vue&type=script&lang=js&"
import style0 from "./cardSubheader.vue?vue&type=style&index=0&id=fcb93b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb93b16",
  null
  
)

export default component.exports